import React from 'react';
import { UiQuill } from '../ui-kit/UiQuill';

/* eslint-disable react/prop-types */
export function UiQuillAdapter({ input, meta, ...rest }) {
  return (
    <UiQuill
      {...input}
      {...rest}
      errorMessage={meta.touched ? meta.error || meta.submitError || '' : ''}
    />
  );
}
